import { ODataObject } from '../../interfaces/odata-model.interface';

export class ConfigModel {
    public constructor(
        private internalKey: string,
        private internalValue: string,
        private internalCategory: string,
    ) {}

    public get key(): string {
        return this.internalKey;
    }

    public get value(): string {
        return this.internalValue;
    }

    public get category(): string {
        return this.internalCategory;
    }

    public toString(): string {
        return 'Key: ' + this.key + ' | Value: ' + this.value + ' | Category: ' + this.category;
    }

    public compareTo(otherConfigModel: ConfigModel): boolean {
        return ConfigModel.compare(this, otherConfigModel);
    }

    public static compare(firstModel: ConfigModel, secondModel: ConfigModel): boolean {
        return (
            firstModel.key === secondModel.key &&
            firstModel.value === secondModel.value &&
            firstModel.category === secondModel.category
        );
    }

    public static fromOData(data: ODataConfigModel): ConfigModel {
        return new ConfigModel(data.Key, data.Value, data.Category);
    }
}

export interface ODataConfigModel extends ODataObject {
    __metadata: {
        id: string;
        uri: string;
        type: string;
    };
    Key: string;
    Value: string;
    Category: string;
}
